import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

import styles from "./Analytics.module.scss";

// data
import { chartData, colors } from "../helper";

const PieChartComponent = () => {
  return (
    <div className={styles.pie__chart__wrapper}>
      <p>
        Total Events: <span>704</span>
      </p>
      <ResponsiveContainer width={"100%"} height={400}>
        <PieChart>
          <Pie
            data={chartData}
            label={(entry) => entry.name}
            fill="#8884d8"
            chartDataKey="value"
            nameKey="name"
          >
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className={styles.custom__tooltip}>
        <p>
          {`${payload[0].value}`} events in {`${payload[0].name}`}
        </p>
      </div>
    );
  }

  return null;
};

export default PieChartComponent;
